import { PdfTemplate } from "components";
import { RegisterDateType } from "../types";
import { RowExportTypePdf } from "types";
import moment from "moment";
import { convertNumber } from "utils";

export function ExportPdf(props: {
    data: RegisterDateType[]
    filter: {
        dateFrom: string,
        dateTo: string
    },
    title: string,
}) {

    const columns = [
        { header: "NO", key: "no", width: 5 },
        { header: "TRADE ID", key: "trade_id", width: 20 },
        { header: "DATE", key: "date", width: 15 },
        { header: "TRADER", key: "trader", width: 10 },
        { header: "REF NO", key: "ref_no", width: 10 },
        { header: "MRK", key: "mrk", width: 10 },
        { header: "MEMO", key: "memo", width: 30 },
        { header: "LOCATION", key: "location", width: 20 },
        { header: "DEBIT", key: "debit", width: 20 },
        { header: "CREDIT", key: "credit", width: 20 },
    ]

    const dataMap: RowExportTypePdf[] = props.data.map((item, index) => ({
        no: index + 1,
        trade_id: item.data_source_code + ' ' + item.trx_code,
        date: moment(item.transaction_date).format("DD/MM/YYYY"),
        trader: item.trader,
        ref_no: item.reference_no,
        mrk: {
            text: (item.reconsiled ? '✔' : '') + ' ' + item.mrk
        },
        memo: item.memo,
        location: item.location_name,
        debit: {
            text: item.position === 1 ? convertNumber(item.amount).intoCurrency : "",
            style: { textAlign: "right" }
        },
        credit: {
            text: item.position === 2 ? convertNumber(item.amount).intoCurrency : "",
            style: { textAlign: "right", color: 'red' }
        },
    }))

    return (
        <PdfTemplate
            data={dataMap}
            module="FINANCE"
            title={props.title}
            column={columns}
            date={`${moment(props.filter.dateFrom).format('DD/MM/YYYY')} - ${moment(props.filter.dateTo).format('DD/MM/YYYY')}`}
        />
    )
}